export enum AvailabilityAction {
  OUT_OF_STOCK = 'OUT_OF_STOCK',
  IN_STOCK = 'IN_STOCK',
  SNOOZE = 'SNOOZE',
  UNSNOOZE = 'UNSNOOZE'
}

export enum OrderType {
  SAMEDAY = 'SAMEDAY',
  PREORDER = 'PREORDER'
}

export enum AvailabilityGroupScope {
  GROUP = 'GROUP',
  SINGLE = 'SINGLE'
}

export enum ItemType {
  PRODUCT = 'PRODUCT',
  MODIFIER = 'MODIFIER'
}
